<template>
	<div>
		<div class="row">
			<div class="col-12">
				<InputText id="name" name="name" :form="values" :errors="errors" maxLength="50"/>
			</div>
			<div class="col-12">
				<div class="input" :class="{ 'input-error': errors['abbreviation'] }">
					<label for="abbreviation">Abbreviation</label>
					<input id="abbreviation" type="text" v-model="values['abbreviation']" maxlength="4" @keyup="errors['abbreviation'] = ''" @keypress="disableSpaces($event)"/>
					<span class="error-message">{{ errors['abbreviation'] }}</span>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-right">
				<button class="button-action" @click="save">{{ newTask ? 'Add Task' : 'Save Changes' }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'

export default {
	components: {
		InputText
	},
	props: [
		'task',
	],
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['name', 'abbreviation'],
			newTask: true
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			if(this.values.abbreviation) {
				this.values.abbreviation.replace(' ', '');
			}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		disableSpaces(evt) {
			evt = (evt) ? evt : window.event
			const  charCode = (evt.which) ? evt.which : evt.keyCode

			if (charCode == 32) {
				evt.preventDefault()
			} else {
				return true
			}
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			const action = this.newTask ? 'create' : 'update'
			const postActionDescription = this.newTask ? 'Added' : 'Updated'

			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`tasks/${action}`, this.values)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Task ${this.values.name} ${postActionDescription}`,
					timeout: 3000
				})
				this.$emit('close');
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		if(this.task) {
			this.values = JSON.parse(JSON.stringify(this.task))
			this.newTask = false
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Tasks/Form.vue